import { Timestamp } from "@/types/date"
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

import { now } from "../date-utils"
import { RootState } from "./redux-store"

export interface TickerSliceState {
  nowNearestMinute: Timestamp
}

export const tickerSliceInitialState: TickerSliceState = {
  nowNearestMinute: now(),
}

const selectSliceState = (state: RootState) => state.tickerSlice

export const selectNowLive = createSelector(
  [selectSliceState],
  (state) => state.nowNearestMinute
)

const tickerSlice = createSlice({
  name: "ticker",
  initialState: tickerSliceInitialState,
  reducers: {
    setNowNearestMinute: (state, action: PayloadAction<Timestamp>) => {
      state.nowNearestMinute = action.payload
    },
  },
})

export type TickerSlice = typeof tickerSlice

export default tickerSlice
